import BreadCrumb from "../../../../components/breadcrumb";
import { UserClient } from "../../../../components/tables/users-tables/client";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { useEffect, useState } from "react";
import { User } from "../../../../data/types";
import { getAllUsers } from "../../../../../src/API/Users/userService";

const breadcrumbItems = [
  { title: "Utilisateurs", link: "/admin-dashboard/utilisateurs" },
];
export default function Users() {
  const [users, setUsers] = useState<User[]>([]);
  const fetchData = async () => {
    const response = await getAllUsers();
    setUsers(response && response.users);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <UserClient data={users} />
        </div>
      </div>
    </>
  );
}
